import React from 'react';
import PropTypes from 'prop-types';
import Svg, { Polygon, Path, G } from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';

function AccordionPlusIcon(props) {
  const {
    color,
    ...svgProps,
  } = props;


  return (

    <Svg
      {...svgProps}
      viewBox="0 0 20 20">
      <Path id="plus" fill-rule="evenodd" fill="#fff" d="m6.28 8.635h-6.28v-2.27h6.28v-6.365h2.44v6.365h6.28v2.27h-6.28v6.365h-2.44z" />
    </Svg>

  );
}


AccordionPlusIcon.defaultProps = {
  height: 20,
  width: 20,
};

AccordionPlusIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

export default pure(AccordionPlusIcon);
